<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick"  :pageData="pageData"></table-page>
    <!--编辑-->
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData">
    </UPDATE>
  </div>
</template>

<script>
//table封装组件
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import UPDATE from '@/components/page/update.vue'
//接口地址url的统一管理
import Qs from 'qs'
import URL from "@/views/crs36/util/url"

let typeStatus= {"0":window.$t("crs.taskType.typeStatus0"),"1":window.$t("crs.taskType.typeStatus1")};
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },

  mounted(){

  },
  methods: {
    /*表格按钮点击事件*/
    bthClick (clickName, row) {
      if (clickName == "update"){
        this.$refs.childUpdate.open(row);
      }else if (clickName == "updateStatus"){

          let status = row.typeStatus == 1 ? 0:1;
          let conf = row.typeStatus == 1 ? window.$t("crs.taskType.typeStatus0"):window.$t("crs.taskType.typeStatus1");
          this.$confirm(window.$t("common.ok")+conf, window.$t("common.tip"), {
            distinguishCancelAndClose: true,
            confirmButtonText: window.$t("common.ok"),
            cancelButtonText: window.$t("common.cancle")
          }).then(() => {
            this.$axios.get(`${URL.taskType.audit}/${row.id}`+'/'+status).then(res => {
              if (res.code == 0){
                this.$refs.childTable.defaultGetData(this.queryData);
                this.$message.success("suc");
              }else{
                this.$message.error(res.message);
              }
            });
          })
      }
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data){
      if(window.$t("common.search") == clickName || "查询" == clickName){
        this.queryData = data;
        this.$refs.childTable.defaultQueryData(data);
      }else if(window.$t("common.add")==clickName){
        this.$refs.childUpdate.open();
      }
    },

    /*新增或跟提交数据触发事件*/
    submit(model){
      //根据是否包含id更新还是添加
      this.dataChanage(URL.taskType.addOrUpdate,model,res => {
        if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("suc");
        }else{
          this.$message.error(res.message);
        }
      })
    },
    dataChanage(url,option,suc,fail){
      this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
        this.$refs.childTable.defaultGetData(this.queryData);
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
        if(fail && (typeof fail == 'function')) fail(res);
      })
    },
  },
  data () {
    return {
      deleteIds:"",
      queryData:{},
      /*新增或更新*/
      updateData:{
        cols:[
          { title: window.$t("crs.task.id"), field: 'id',hidden:true},
          { title: 'lang', field: 'lang',data:"EV",hidden:true},
          { title: window.$t("crs.taskType.typeName"), field: 'typeName',required:true},
          { title: window.$t("crs.taskType.titleNameEn"), field: 'titleNameEn',required:true},
          { title: window.$t("crs.taskType.titleNameVn"), field: 'titleNameVn',required:true},
          { title: window.$t("crs.taskType.typeDescEn"), field: 'typeDescEn',type:6,required:true,uploadUrl:URL.img.upload},
          { title: window.$t("crs.taskType.typeDescVn"), field: 'typeDescVn',type:6,required:true,uploadUrl:URL.img.upload},
          { title: window.$t("crs.taskType.typeStatus"), field: 'typeStatus',type:3,optionList:typeStatus,isNumber:true,data:0,required:true},
        ]
      },
      /*from查询表单*/
      formData:{
        hasLable: true,
        cols:[
          { title: window.$t("crs.task.id"), field: 'id',hidden:true},
          { title: window.$t("crs.taskType.typeName"), field: 'typeName'},
          { title: window.$t("crs.taskType.typeStatus"),field: 'status',type:2,optionList:typeStatus,isNumber:true},
          { title: window.$t("crs.taskType.startDate"), field: 'startDate',type:5,format:"yyyy-MM-dd HH:mm:ss"},
          { title: window.$t("crs.taskType.endDate"), field: 'endDate',type:5,format:"yyyy-MM-dd HH:mm:ss"},
          {click:window.$t("common.search")},
          {click:window.$t("common.add")},
        ]
      },

      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: URL.taskType.query,
        selection: false,
        sequence: false,
        method:"get",
        cols: [
          { title: 'ID', field: 'id'},
          { title: window.$t("crs.taskType.typeName"), field: 'typeName'},
          { title: window.$t("crs.taskType.typeStatus"), field: 'typeStatus',render:(data)=>{
              return typeStatus[data];
            }},
          { title: window.$t("crs.taskType.creator"), field: 'creator'},
          { title: window.$t("crs.taskType.createDate"), field: 'createDate'},
          { title: window.$t("crs.taskType.updateDate"), field: 'updateDate'},
          {title: window.$t("common.handle"),width:'330px',btnClick:[
              {
                name:window.$t("common.edit"),click:"update",type:"text"
              },
              {
                name:(data,full)=>{
                  if(full.typeStatus == 0){
                    return window.$t("crs.taskType.typeStatus1")
                  }else{
                    return window.$t("crs.taskType.typeStatus0")
                  }
                },click:"updateStatus",type:"text",confirm:false
              },

            ]
          },
        ]
      }
    }
  }
}
</script>
